var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-error"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":50}}),_c('path',{attrs:{"d":"M33 33 L67 67z"}}),_c('path',{attrs:{"d":"M33 67 L67 33z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }